module.exports = __webpack_public_path__ + "static/img/A35.3b95fb7b.jpg";